module.exports = __webpack_public_path__ + "img/item5-3.d61f0193.png";